import CarouselItem from './Item';

const PARTNERS = [
  {
    alt: '123 Milhas',
    darkImageName: null,
    imageName: '123milhas.svg',
    lightImageName: null,
  },
  {
    alt: 'Aliexpress',
    darkImageName: null,
    imageName: 'aliexpress.svg',
    lightImageName: null,
  },
  {
    alt: 'Casas Bahia',
    darkImageName: null,
    imageName: 'casas-bahia.svg',
    lightImageName: null,
  },
  {
    alt: 'Espaço Laser',
    darkImageName: null,
    imageName: 'espaco-laser.svg',
    lightImageName: null,
  },
  {
    alt: 'Insider',
    darkImageName: null,
    imageName: 'insider.svg',
    lightImageName: null,
  },
  /**
   * Applying filters in base logo cases aliasing in specific parts of logo and
   * because of that we prefer have dedicated files for each type of theme.
   */
  {
    alt: 'Mercado Livre',
    darkImageName: 'mercado-livre@dark.svg',
    imageName: null,
    lightImageName: 'mercado-livre@light.svg',
  },
  {
    alt: 'Multi',
    darkImageName: null,
    imageName: 'multi.svg',
    lightImageName: null,
  },
  {
    alt: 'Netshoes',
    darkImageName: null,
    imageName: 'netshoes.svg',
    lightImageName: null,
  },
  {
    alt: 'Samsung',
    darkImageName: null,
    imageName: 'samsung.svg',
    lightImageName: null,
  },
  {
    alt: 'Stanley',
    darkImageName: null,
    imageName: 'stanley.svg',
    lightImageName: null,
  },
  {
    alt: 'Wine',
    darkImageName: null,
    imageName: 'wine.svg',
    lightImageName: null,
  },
];

const Carousel = () => (
  <div className="relative w-full overflow-hidden">
    <div className="flex animate-[carousel--autoplay_30s_linear_infinite] gap-x-6 md:gap-x-7">
      {[...PARTNERS, ...PARTNERS, ...PARTNERS].map(
        ({ alt, imageName, darkImageName, lightImageName }, i) => (
          <CarouselItem
            key={alt + i}
            alt={alt}
            darkImageName={darkImageName}
            imageName={imageName}
            lightImageName={lightImageName}
          />
        )
      )}
    </div>
  </div>
);

export default Carousel;
